import React, { useState, useEffect, createContext, useContext } from "react";
import Layout from "./pages/layout/layout.js";
import MLogin from "./pages/login/MyLogin.js";
import Register from "./pages/register/register.js";
import { HashRouter, BrowserRouter, Routes, Route, Link } from "react-router-dom";
import './App.css';
import UserTrips from "./pages/usertrips/UserTrips.js";
import CreateNewTrip from "./pages/newtrip/CreateNewTrip.js";
import NotFound from "./pages/notfound/NotFound.js";
import TripAI from "./pages/tripai/TripAI.js";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AppContext = createContext();

function App() {
  const [userCtx, setUserCtx] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/auth-check`, { method: 'GET', credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(data => setUserCtx(data))
      .catch(() => setUserCtx(null));
  }, []);

  return (
    <AppContext.Provider value={{ userCtx, setUserCtx }}>
      <HashRouter>
       <Routes>
        <Route path="/" element={<MLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/app" element={<Layout />} />
    
        <Route path="/createTrip" element={<CreateNewTrip />}/> 
        <Route path="/userTrips" element={<UserTrips />}/> 
        <Route path="/trip-details/:tripId" element={<Layout />} />
        <Route path="trip-details/:tripId" element={<Layout />} />
        <Route path="/trip-ai" element={<TripAI />} />
        <Route path="*" element={<MLogin />} />
        </Routes> 
      </HashRouter> 
      </AppContext.Provider>
  );  
}

export default App;
